import Vue from "vue";
import App from "./App.vue";
import VModal from "vue-js-modal";
import axios from "./http_client";
import VueAxios from "vue-axios";
import store from "./store";
import index from "./router";
import "./assets/styles/main.scss";


Vue.use(VModal);
Vue.use(VueAxios, axios);

// const host = window.location.host;
const host = window.location.host;
const parts = host.split(".");
const domainLength = 3;


let processes = [

    //     domain: *.eap.pl - for routing
    //     title: <title> tag
    //     $saxId: For API purposes
    //     $phone: Contact number
    //     $color: Applies to everything colored
    //     $logo: Will be displayed in header along with EAP logo
    //     $processes: List of supported user flows
    //     $auth: Verification mode, will be used to find user policy,

    {
        domain: 'creditagricole',
        title: "Credit Agricole Assistance",
        $saxId: "974",
        $phone: "+48222055152",
        $color: "#008991",
        $logo: "credit-agricole-logo.svg",
        $processes: ['home', 'med'],
        $auth: 'pesel',
    }, {
        domain: 'pakietniezawodny',
        title: "Pakiet niezawodny",
        $saxId: "942",
        $phone: "+48222037976",
        $color: "#9c0031",
        $logo: "europa.ubezpieczenia-logo.svg",
        $processes: ['home', 'med'],
        $auth: 'pesel',
    }, {
        domain: 'pakietbardzopomocny',
        title: "Pakiet Bardzo Pomocny",
        $saxId: "760",
        $phone: "+48222037500",
        $color: "#c80358",
        $logo: "millennium-logo.svg",
        $processes: ['home', 'med'],
        $auth: 'pesel',
    }, {
        domain: 'pomoc',
        title: "EAP Pomoc",
        $saxId: "209",
        $phone: "+48222055080",
        $color: "#314294",
        $logo: "logo2.png",
        $processes: ['home', 'med', 'car'],
        $auth: 'userName',
    }, {
        domain: 'interpolska',
        title: "Assistance Medyczny",
        $saxId: "932",
        $phone: "+48223337777", // TODO
        $color: "#012169",
        $logo: "inter-brand.png",
        $processes: ['med'],
        $auth: 'pesel',
    }, {
        domain: 'wartadom',
        title: "Warta Dom",
        $saxId: "1025",
        $phone: "+48222037515", // TODO
        $color: "#003866",
        $logo: "warta.png",
        $processes: ['home'],
        $auth: 'policy',
    }, {
        domain: 'generalidom',
        title: "Generali Dom i Rodzina",
        $saxId: "852",
        $phone: "+48222055025", // TODO
        $color: "#e6563c",
        $logo: "generali.png",
        $processes: ['home'],
        $auth: 'policy',
    }
];

let defaultService = 2;



const router = () => {
    let process = {};

    if (parts.length === domainLength - 1 || parts[0] === "www" || parts[0].match('localhost')) {
        process = processes[defaultService];
    } else {
        for (let p of processes)
            if (p.domain === parts[0])
                process = p;
    }

    window.hostname = `${process.domain}.eap.pl`

    document.title = process.title;
    delete process.title;
    delete process.domain;

    for (let f in process)
        if (process.hasOwnProperty(f))
            Vue.prototype[f] = process[f]

    return index;
};

new Vue({
    el: "#app",
    router: router(),
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js